import type Project from "@/types/project";
import ProjectFileIcon from "@/components/projects/ProjectFileIcon";
import { X } from "lucide-react";

interface FileTabsProps {
    projects: Project[];
    openProjectIds: string[];
    activeProject: string;
    activeTab: string;
    handleOpenProject: (projectId: string) => void;
    handleCloseProject: (projectId: string) => void;
}

export default function FileTabs({
    projects,
    openProjectIds,
    activeProject,
    activeTab,
    handleOpenProject,
    handleCloseProject,
}: FileTabsProps) {
    const openedProjects = openProjectIds
        .map((id) => projects.find((p) => p.id === id))
        .filter((p): p is Project => Boolean(p));

    return (
        <div className="flex bg-[#050505] border-b border-white/15 overflow-x-auto overflow-y-hidden h-12 max-w-full [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
            {openedProjects.map((project) => {
                const isSelected = activeProject === project.id;
                return (
                    <button
                        key={project.id}
                        type="button"
                        onClick={() => handleOpenProject(project.id)}
                        className={`flex items-center gap-2 px-4 py-2 text-xs border-r border-white/15 ${isSelected && activeTab === "file" ? "tab-active" : "text-on-surface-variant hover:bg-white/5 bg-[#0a0a0a]"
                            }`}
                    >
                        <ProjectFileIcon fileIcon={project.fileIcon} />
                        <span className="font-mono text-nowrap">{project.fileName}</span>
                        <span
                            className="material-symbols-outlined text-[12px] opacity-60 hover:opacity-100"
                            onClick={(event) => {
                                event.stopPropagation();
                                handleCloseProject(project.id);
                            }}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(event) => {
                                if (event.key === "Enter" || event.key === " ") {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    handleCloseProject(project.id);
                                }
                            }}
                        >
                            <X className="size-3.5" />
                        </span>
                    </button>
                );
            })}
            {openedProjects.length === 0 ? (
                <div className="flex items-center px-4 text-xs font-mono text-on-surface-variant">No open projects</div>
            ) : null}
        </div>
    );
}
